import { Popover } from 'antd';
import React from 'react';
import { If, Then, Else } from 'react-if';
import cn from 'classnames';

import { formatThousands } from '@/utils/util-functions';

import BarPopover from '../BarPopover/BarPopover';
import { StyledRange } from '../styled';

export const getBar = (scale, i, isRelativeScale, totalRange, value, targetValue, unit, $specialStyleKPIBox) => {
  if (i === 0) return undefined;

  const range = isRelativeScale
    ? ((scale.values[i] - scale.values[i - 1]) / totalRange) * 100
    : (100 / scale.values.length) * 100;
  let isInRange: boolean;
  if (i === 1) {
    // first bar
    isInRange = value < scale.values[0] || (value >= scale.values[i - 1] && value < scale.values[i]);
  } else if (i === scale.values.length - 1) {
    // last bar
    isInRange = value >= scale.values[i - 1];
  } else {
    // middle bars
    isInRange = value >= scale.values[i - 1] && value < scale.values[i];
  }
  const rangeColor = scale.colors[i - 1];
  const fadedColor = scale.fadedColors[i - 1];
  const isTargetValueInRange = targetValue > scale.values[i - 1] && targetValue < scale.values[i];
  return (
    <If key={i} condition={i < scale.values.length - 1}>
      <Then>
        <Popover
          placement={'bottom'}
          content={
            <BarPopover
              min={scale.values[i - 1]}
              max={scale.values[i]}
              unit={unit}
              value={isTargetValueInRange ? targetValue : undefined}
            />
          }
        >
          <StyledRange
            key={i}
            className="bar"
            $range={range}
            $color={rangeColor}
            $fadedColor={fadedColor}
            $isInRange={isInRange}
          >
            <div className={cn('values-labels', isInRange && 'in-range-value')}>
              <span>
                {scale.shouldShowEdgeOnly && i > 1 ? (
                  ''
                ) : (
                  <>
                    <span
                      {...($specialStyleKPIBox && { className: 'bar-value' })}
                      {...(isInRange && { className: 'in-range-value' })}
                    >
                      {formatThousands(scale.values[i - 1])}
                    </span>
                    {$specialStyleKPIBox && <span className="bar-unit">{unit}</span>}
                  </>
                )}
              </span>
            </div>
          </StyledRange>
        </Popover>
      </Then>
      <Else>
        <Popover
          placement={'bottom'}
          content={<BarPopover min={scale.values[i - 1]} max={scale.values[i]} unit={unit} />}
        >
          <StyledRange
            key={i}
            className="bar"
            $range={range}
            $color={rangeColor}
            $isInRange={isInRange}
            $fadedColor={fadedColor}
          >
            <div className={cn('values-labels', isInRange && 'in-range-value')}>
              <span>{scale.shouldShowEdgeOnly && i > 1 ? '' : formatThousands(scale.values[i - 1])}</span>
              <span className="max">
                <span {...($specialStyleKPIBox && { className: 'bar-value' })}>{formatThousands(scale.values[i])}</span>
                {$specialStyleKPIBox && <span className="bar-unit">{unit}</span>}
              </span>
            </div>
          </StyledRange>
        </Popover>
      </Else>
    </If>
  );
};

export const isValueInTargetRange = (scale, value) => {
  return value > scale.values[1] && value < scale.values[2];
};
